import { render, staticRenderFns } from "./CalendarTermDialog.vue?vue&type=template&id=f2b396c4&scoped=true&"
import script from "./CalendarTermDialog.vue?vue&type=script&lang=js&"
export * from "./CalendarTermDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b396c4",
  null
  
)

export default component.exports